import React from "react";
import "../css/paymentSummary.css";

const PaymentSummary = ({ cart, tax }) => {

  // ✅ Customer subtotal only (ignore commissions)
  const subtotal = cart.reduce((sum, item) => {
    if (item.exclude_from_total) return sum;
    return sum + (item.price * item.quantity);
  }, 0);

  // ✅ Commission total (display only)
  const commission = cart.reduce((sum, item) => {
    return item.is_commission
      ? sum + (item.price * item.quantity)
      : sum;
  }, 0);

  // ✅ Discounts only apply to customer-paid items
  const discount = cart.reduce((sum, item) => {

    if (item.exclude_from_total) return sum;

    if (!item.discount || isNaN(item.discount)) return sum;

    if (item.discountType === "percent") {
      return (
        sum +
        (item.price * item.quantity) *
          (parseFloat(item.discount) / 100)
      );
    }

    if (item.discountType === "cash") {
      return sum + parseFloat(item.discount);
    }

    return sum;

  }, 0);

  const total = subtotal - discount + tax;

  return (
    <div className="payment-summary">

      <div className="summary-item">
        <span>Subtotal:</span>
        <span>${subtotal.toFixed(2)}</span>
      </div>

      <div className="summary-item">
        <span>Discounts:</span>
        <span>-${discount.toFixed(2)}</span>
      </div>

      <div className="summary-item">
        <span>Tax:</span>
        <span>${tax.toFixed(2)}</span>
      </div>

      {/* Only show if a commission exists */}
      {commission > 0 && (
        <div className="summary-item commission">
          <span>Commission Earned:</span>
          <span>${commission.toFixed(2)}</span>
        </div>
      )}

      <div className="summary-total">
        <span>Total:</span>
        <span>${total.toFixed(2)}</span>
      </div>

    </div>
  );
};

export default PaymentSummary;